import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Drawer, Icon, Input, Select, Tooltip, Spin } from "antd";
import { EMPTY_OBJECT } from "tbase/app.constants";
import './CreateTicket.scss';
import Editor from "../../atoms/Editor";
import LookupHelper from "../../atoms/LookupHelper";
import { addAttachment, removeAttachment } from "./CreateTicket.helper";
import { isEmpty, notificationHelper } from "../../utils/helper";
import Utility from "../../utils/Utility";
import { uploadAttachments } from "../../api/urls";
import UploadAsModal from '../UploadAsModal';
import TicketFields from "../../atoms/TicketFields";
import Loader from "../../atoms/Loader";
import { fetchGroupLookUpApi, searchUsersApi, uploadAttachmentApi } from "../../api/Header";
const P_TAG = '<p>';
const P_TAG_WITH_INLINE_STYLES = '<p style="line-height: 2rem; min-height: 2rem; margin: 0; padding: 0">';
const getPopupContainer = () => {
  if (process.env.NODE_ENV === 'test') return node => node.parentNode;
  return;
};
const {
  Option
} = Select;
const getInitialDescription = desc => {
  if (typeof desc !== 'string') return EMPTY_OBJECT;
  const text = (desc || '').trim();
  return text ? {
    json: [{
      type: 'paragraph',
      content: [{
        type: 'text',
        text
      }]
    }],
    text,
    html: "<div style=\"font-size: 14px;font-family: &quot;Proxima-Nova-Regular&quot;, Arial, Helvetica, sans-serif;\"><p style=\"margin-top: 0.36em; margin-bottom: 0.36em; line-height: 1.43em; min-height: 1.43em;\">".concat(text, "</p></div>")
  } : EMPTY_OBJECT;
};
const CreateTicket = props => {
  var _ticketFields$associa, _fieldsMap$priority, _fieldsMap$type;
  const {
    actions,
    apiBaseUrl,
    userDetails,
    onClose,
    supportBrands,
    supportForms,
    ticketFields,
    ticketCreationFields,
    onSuccess,
    ticketLoading,
    ticketDrawerApiStatus,
    initialPayload
  } = props;
  const {
    fields
  } = ticketCreationFields || {};
  const [subject, setSubject] = useState('');
  const [brand, setBrand] = useState('');
  const [form, setForm] = useState([]);
  const [description, setDescription] = useState({});
  const [attachments, setAttachments] = useState([]);
  const [showAddAttachmentsModal, setShowAddAttachmentsModal] = useState(false);
  const [assignee, setAssignee] = useState('');
  const [priority, setPriority] = useState('');
  const [ticketType, setTicketType] = useState('incident');
  const [requester, setRequester] = useState('');
  const [source, setSource] = useState('portal');
  const [formFields, setFormFields] = useState([]);
  const [disableCreateTicket, setDisableCreateTicket] = useState(false);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [dealerId, setDealerId] = useState(0);
  const fieldsMap = useMemo(() => (fields || []).reduce((result, item) => _objectSpread(_objectSpread({}, result), {}, {
    [item.name]: item
  }), {}), [fields]);
  const submitter = "".concat(userDetails.name, " <").concat(userDetails.email, ">");
  useEffect(() => {
    actions.fetchSupportBrands(apiBaseUrl);
    actions.fetchTicketCreationFields(apiBaseUrl);
  }, [actions, apiBaseUrl]);
  useEffect(() => {
    if (!requester) {
      setRequester(userDetails.email || '');
    }
  }, [userDetails]);
  useEffect(() => {
    if (!Utility.isEmptyElement(initialPayload)) {
      const dispatchConfig = {
        subject: setSubject,
        brand: id => id && onBrandSelect(id),
        form: setForm,
        description: text => setDescription(getInitialDescription(text)),
        attachments: setAttachments,
        assignee: setAssignee,
        priority: setPriority,
        ticketType: setTicketType,
        requester: setRequester,
        source: setSource,
        dealerId: setDealerId
      };
      Object.entries(initialPayload).forEach(_ref => {
        let [key, value] = _ref;
        const dispatch = dispatchConfig[key] || (() => {});
        dispatch(value);
      });
    }
  }, [initialPayload, supportBrands]);
  const onSubjectChange = e => {
    const {
      value
    } = e.target;
    setSubject(value);
  };
  const handleOnClose = isSuccess => {
    setDisableCreateTicket(false);
    if (isSuccess) {
      onClose(false);
    }
  };
  const onAddAttachment = useCallback(file => {
    const attachmentsToAdd = addAttachment(attachments, file);
    setAttachments(attachmentsToAdd);
  }, [attachments]);
  const processUpload = useCallback(async file => {
    setIsFileUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await uploadAttachmentApi(formData);
      setIsFileUploading(false);
      onAddAttachment({
        response
      });
      return true;
    } catch (error) {
      setIsFileUploading(false);
      notificationHelper('error', __('Error'), 'Upload api failed', 5, () => {}, '');
      console.error('file upload error', error);
    }
    return false;
  }, [onAddAttachment]);
  const onUploadAttachment = useCallback((newFiles, callback) => {
    if (!isEmpty(newFiles)) {
      newFiles.map(file => processUpload(file, callback));
    }
  }, [processUpload]);
  const onBrandSelect = value => {
    const brand = supportBrands.find(item => item.id === value);
    if (brand) {
      actions.setSupportForm(brand.forms);
      setBrand(brand);
      setForm(brand.default_form);
      actions.fetchTicketFields(apiBaseUrl, brand.default_form);
    }
  };
  const onFormSelect = value => {
    setForm(value);
    actions.fetchTicketFields(apiBaseUrl, value);
  };
  const onRemoveAttachment = useCallback((file, event, isTempFile) => {
    const removeFile = file;
    if (!isEmpty(removeFile)) {
      if (file && isTempFile && event) {
        event.preventDefault();
        removeFile.uid = file.id;
      }
      const attachmentsToAdd = removeAttachment(attachments, removeFile);
      setAttachments(attachmentsToAdd);
    }
  }, [attachments]);
  const renderDrawerHeader = () => /*#__PURE__*/React.createElement("div", {
    className: "createTicket-drawer-header"
  }, /*#__PURE__*/React.createElement("span", {
    className: "createTicket_label"
  }, __('Create Ticket')));
  const handleCreateTicket = () => {
    const bodyHtml = description.html || '';
    const fieldsToCheck = [{
      key: "subject",
      value: subject,
      errorMessage: __('Subject is empty'),
      required: true
    }, {
      key: "brand_id",
      value: brand.id,
      errorMessage: __('Brand id is empty'),
      required: true
    }, {
      key: "form_id",
      value: form,
      errorMessage: __('Form id is empty'),
      required: true
    }, {
      key: "description",
      value: description.text,
      errorMessage: __('Description is a mandatory field'),
      required: true
    }, {
      key: "requester",
      value: requester,
      errorMessage: __('Requester is empty'),
      required: true
    }, {
      key: "priority",
      value: priority,
      errorMessage: __('Priority is empty'),
      required: true
    }, {
      key: "type",
      value: ticketType
    }, {
      key: "source",
      value: source
    }, {
      key: "attachments",
      value: attachments
    }, {
      key: "body",
      value: description.text
    }, {
      key: "body_formatted",
      value: JSON.stringify(description.json)
    }, {
      key: "body_html",
      value: bodyHtml.replaceAll(P_TAG, P_TAG_WITH_INLINE_STYLES)
    }, {
      key: "custom_fields",
      value: formFields
    }];

    // Validate the required form fields
    for (const field of fieldsToCheck) {
      if (field.required && isEmpty(field.value)) {
        notificationHelper('error', __('Error'), field.errorMessage, 5, () => {}, '');
        return;
      }
    }

    // Generate payload for form
    const payload = {};
    for (const field of fieldsToCheck) payload[field.key] = field.value;
    if (!isEmpty(assignee)) {
      const [userGroup, assigneeEmail] = assignee.split('\\');
      payload.user_group = userGroup;
      if (assigneeEmail) {
        payload.assignee = assigneeEmail;
      } else {
        payload.assignee = '';
      }
    } else {
      payload.assignee = '';
    }
    actions.createNewTicket(apiBaseUrl, payload, onSuccess, dealerId).then(handleOnClose);
    setDisableCreateTicket(true);
  };
  const getTicketFields = useCallback(data => {
    const payload = [];
    data.map(item => item.value ? payload.push({
      id: item.id,
      value: item.value
    }) : '');
    setFormFields(payload);
  }, []);
  const fieldConfig = [{
    shouldRender: true,
    label: 'Subject',
    required: true,
    component: /*#__PURE__*/React.createElement(Input, {
      className: "createTicket_input",
      placeholder: __('Type Here'),
      onChange: onSubjectChange,
      value: subject
    })
  }, {
    shouldRender: true,
    label: 'Brand',
    required: true,
    component: /*#__PURE__*/React.createElement(Select, {
      className: "createTicket_input",
      placeholder: __('Select Brand'),
      onSelect: onBrandSelect,
      filterOption: (inputValue, option) => option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0 || option.props.value.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0,
      showSearch: true,
      value: brand.id,
      getPopupContainer: getPopupContainer()
    }, supportBrands.map(brand => /*#__PURE__*/React.createElement(Option, {
      key: brand.id,
      value: brand.id
    }, brand.name)))
  }, {
    shouldRender: brand,
    // Placeholder for condition
    label: 'Form',
    required: true,
    component: /*#__PURE__*/React.createElement(Select, {
      className: "createTicket_input",
      placeholder: __('Select Form'),
      onSelect: onFormSelect,
      showSearch: true,
      filterOption: (inputValue, option) => option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0 || option.props.value.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0,
      value: form,
      getPopupContainer: getPopupContainer()
    }, supportForms.map(formValue => /*#__PURE__*/React.createElement(Option, {
      key: formValue.id,
      value: formValue.id
    }, formValue.name)))
  }, {
    shouldRender: (ticketFields === null || ticketFields === void 0 || (_ticketFields$associa = ticketFields.associated_fields_values) === null || _ticketFields$associa === void 0 ? void 0 : _ticketFields$associa.length) > 0 && (brand === null || brand === void 0 ? void 0 : brand.enable_form_based_fields),
    component: /*#__PURE__*/React.createElement(TicketFields, {
      isLoading: ticketLoading.ticketFields,
      fieldsData: ticketFields,
      name: __('Ticket Fields'),
      getTicketFields: getTicketFields,
      url: apiBaseUrl
    })
  }, {
    shouldRender: true,
    label: 'Description',
    required: true,
    component: /*#__PURE__*/React.createElement("div", {
      className: "createTicket_input"
    }, /*#__PURE__*/React.createElement("div", {
      className: "createTicket-editor"
    }, /*#__PURE__*/React.createElement(Editor, {
      plugins: ['image', 'list', 'mention', 'link'],
      marks: [],
      allowUploads: true,
      canDeleteFile: true,
      hasInlineStyles: true,
      files: attachments,
      renderAsHtml: false,
      defaultValue: description.json || '',
      onChange: val => setDescription(val),
      pluginOptions: {
        media: {
          onUpload: onUploadAttachment,
          inline: false
        },
        image: {
          onUpload: onUploadAttachment,
          inline: false
        }
      },
      onDeleteFile: (file, event) => onRemoveAttachment(file, event, true)
    })), isFileUploading ? /*#__PURE__*/React.createElement("div", {
      style: {
        margin: '15px 0px'
      }
    }, __('Uploading file ...'), " ", /*#__PURE__*/React.createElement(Spin, {
      indicator: /*#__PURE__*/React.createElement(Icon, {
        type: "loading",
        style: {
          fontSize: 15
        },
        spin: true
      })
    })) : '', /*#__PURE__*/React.createElement(Tooltip, {
      placement: "bottom",
      title: __('Click to add Attachment')
    }, /*#__PURE__*/React.createElement("div", {
      className: "ticketDetails__attachment",
      role: "button",
      tabIndex: "0",
      onClick: () => setShowAddAttachmentsModal(true)
    }, /*#__PURE__*/React.createElement("div", {
      className: "ticketDetails__attachmentCount"
    }, attachments.length || ''), /*#__PURE__*/React.createElement(Icon, {
      className: "attachmentIcon",
      type: "paper-clip"
    }))), /*#__PURE__*/React.createElement(UploadAsModal, {
      actionURL: "".concat(apiBaseUrl).concat(uploadAttachments),
      attachments: attachments,
      showModal: showAddAttachmentsModal,
      onAddAttachment: file => onAddAttachment(file),
      onCancel: () => setShowAddAttachmentsModal(false),
      onRemoveAttachment: file => onRemoveAttachment(file)
    }))
  }, {
    shouldRender: true,
    label: 'Assignee',
    required: false,
    component: /*#__PURE__*/React.createElement(LookupHelper, {
      apiBaseUrl: apiBaseUrl,
      onChange: val => setAssignee(val),
      apiCall: fetchGroupLookUpApi,
      placeholder: 'Search Assignee',
      isGroup: true,
      labelKey: 'name',
      valueKey: 'email'
    })
  }, {
    shouldRender: true,
    label: 'Priority',
    required: true,
    component: /*#__PURE__*/React.createElement(Select, {
      className: "createTicket_input",
      placeholder: __('Enter Priority'),
      value: priority || undefined,
      onSelect: val => setPriority(val),
      getPopupContainer: getPopupContainer()
    }, (_fieldsMap$priority = fieldsMap.priority) === null || _fieldsMap$priority === void 0 ? void 0 : _fieldsMap$priority.options.map(_ref2 => {
      let {
        id,
        name,
        value
      } = _ref2;
      return /*#__PURE__*/React.createElement(Option, {
        key: id,
        value: "".concat(value)
      }, __("".concat(name)));
    }))
  }, {
    shouldRender: true,
    label: 'Ticket Type',
    required: true,
    component: /*#__PURE__*/React.createElement(Select, {
      className: "createTicket_input",
      onSelect: val => setTicketType(val),
      value: ticketType,
      getPopupContainer: getPopupContainer()
    }, (_fieldsMap$type = fieldsMap.type) === null || _fieldsMap$type === void 0 ? void 0 : _fieldsMap$type.options.map(_ref3 => {
      let {
        id,
        name,
        value
      } = _ref3;
      return /*#__PURE__*/React.createElement(Option, {
        key: id,
        value: "".concat(value)
      }, __("".concat(name)));
    }))
  }, {
    shouldRender: true,
    label: 'Requester',
    required: true,
    component: /*#__PURE__*/React.createElement(LookupHelper, {
      apiBaseUrl: apiBaseUrl,
      onChange: val => setRequester(val),
      defaultValue: requester === userDetails.email ? submitter : requester,
      apiCall: searchUsersApi,
      placeholder: 'Search Requester',
      responseKey: 'users',
      labelKey: 'name',
      valueKey: 'email'
    })
  }, {
    shouldRender: true,
    label: 'Submitter',
    required: false,
    component: /*#__PURE__*/React.createElement("span", {
      className: "createTicket_input"
    }, submitter)
  }, {
    shouldRender: true,
    label: 'Source',
    required: false,
    component: /*#__PURE__*/React.createElement(Select, {
      className: "createTicket_input",
      onSelect: val => setSource(val),
      value: source,
      getPopupContainer: getPopupContainer()
    }, /*#__PURE__*/React.createElement(Option, {
      value: "portal"
    }, __('Portal')), /*#__PURE__*/React.createElement(Option, {
      value: "call"
    }, __('Call')))
  }];
  const renderField = config => {
    if (!config.shouldRender || config.required && !config.component) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "createTicket_field"
    }, /*#__PURE__*/React.createElement("span", {
      className: "createTicket_label"
    }, config.label, config.required ? /*#__PURE__*/React.createElement("span", {
      className: "createTicket_label-superScript"
    }, __('*')) : ''), config.component);
  };
  const renderTicket = () => {
    if (ticketDrawerApiStatus) {
      onClose(false);
      notificationHelper('error', __('Error'), 'API not available for create ticket', 5, () => {}, '');
    } else return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "createTicket-drawer-body"
    }, fieldConfig.map((config, index) => /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, renderField(config)))), renderTicketFooter());
  };
  const renderTicketFooter = () => /*#__PURE__*/React.createElement("div", {
    className: "createTicket_footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "createTicket_btnContainer"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn_container btn_cancel",
    onClick: handleOnClose,
    type: "text"
  }, __('Cancel')), /*#__PURE__*/React.createElement(Button, {
    className: "btn_container btn_create",
    loading: ticketLoading.createTicket,
    disabled: disableCreateTicket,
    onClick: handleCreateTicket,
    type: "primary"
  }, __('Create Ticket'))));
  return /*#__PURE__*/React.createElement(Drawer, {
    title: renderDrawerHeader(),
    placement: "right",
    closable: false,
    onClose: handleOnClose,
    className: "createTicket-drawer",
    width: "78rem",
    visible: true,
    destroyOnClose: true
  }, ticketLoading.supportBrands || ticketLoading.ticketCreationFields || ticketLoading.userDetails ? /*#__PURE__*/React.createElement(Loader, {
    id: "create-ticket-drawer"
  }) : renderTicket());
};
export default CreateTicket;